module.exports = __webpack_public_path__ + "img/utilitylight_stopped.e223548f.svg";